import './App.css';
import Home from './components/Home.js';
import AboutUs from './components/AboutUs.js';
import Services from './components/Services.js';
import { BrowserRouter,Routes,Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/servicesandproducts" element={<Services />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
